import { BnplLimitsApplicationSlugEnum } from '.spec/self-care/tsTypes';

export const BNPL_TERMINAL_SLUGS: BnplLimitsApplicationSlugEnum[] = [
	BnplLimitsApplicationSlugEnum.SUCCESS,
	BnplLimitsApplicationSlugEnum.REJECTED,
	BnplLimitsApplicationSlugEnum.AML_PEP_REQUIRED,
];

export const isTerminalSlug = (slug?: BnplLimitsApplicationSlugEnum | null): boolean =>
	slug != null && BNPL_TERMINAL_SLUGS.includes(slug);

export const GA_ECAT = 'BNPL Limit Setup';
